import React from 'react';

export const TestimonialCard: React.FC<{ quote: string; name: string; title: string; avatar: string }> = ({ quote, name, title, avatar }) => (
    <div className="h-full flex flex-col justify-between bg-card p-8 rounded-lg border border-border">
        <p className="text-muted-foreground italic mb-4 flex-grow">"{quote}"</p>
        <div className="flex items-center mt-4">
            <img src={avatar} alt={name} className="w-12 h-12 rounded-full mr-4 border-2 border-primary/50" />
            <div>
                <p className="font-bold text-card-foreground">{name}</p>
                <p className="text-sm text-muted-foreground">{title}</p>
            </div>
        </div>
    </div>
);